import { useTranslation } from 'react-i18next';

import { Period } from 'components/AnalyticsPage/Periods';

interface VulsChartTitleProps {
  title: string;
  period: Period;
  handlePeriodChange: (newPeriod: Period) => void;
  startDate: string;
  setStartDate: (date: string) => void;
  endDate: string;
  setEndDate: (date: string) => void;
  vulType: string;
  setVulType: (value: string) => void;
}

const VulsChartTitle: React.FC<VulsChartTitleProps> = ({
  title,
  period,
  handlePeriodChange,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  vulType,
  setVulType,
}) => {
  const { t } = useTranslation();
  return (
    <div className="d-flex flex-lg-row flex-column  justify-content-between align-items-center">
      <div className="d-flex align-items-center gap-3">
        <h4 className="m-0" style={{ whiteSpace: 'nowrap' }}>
          {title}
        </h4>
        <select className="form-select rounded-pill" value={vulType} onChange={e => setVulType(e.target.value)}>
          <option value="all_vuls">{t('ChartsAnalitics.vuls_period_line_chart.filter.all')}</option>
          <option value="practice_vuls">{t('ChartsAnalitics.vuls_period_line_chart.filter.practice')}</option>
          <option value="sanitary_vuls">{t('ChartsAnalitics.vuls_period_line_chart.filter.sanitar')}</option>
          <option value="technical_vuls">{t('ChartsAnalitics.vuls_period_line_chart.filter.tehnical')}</option>
        </select>
      </div>

      <div className="d-flex align-items-center gap-2">
        {period === Period.CUSTOM && (
          <div className="d-flex align-items-center gap-2">
            <input
              type="date"
              className="form-control"
              value={startDate}
              onChange={e => setStartDate(e.target.value)}
            />
            <input type="date" className="form-control" value={endDate} onChange={e => setEndDate(e.target.value)} />
          </div>
        )}
        <button
          className="btn btn-ghost-success waves-effect waves-light"
          onClick={() => handlePeriodChange(Period.CUSTOM)}
          disabled={period === Period.CUSTOM}
        >
          {t('ChartsAnalitics.filters.custom')}
        </button>
        <button
          className="btn btn-ghost-success waves-effect waves-light"
          onClick={() => handlePeriodChange(Period.YEAR)}
          disabled={period === Period.YEAR}
        >
          {t('ChartsAnalitics.filters.year')}
        </button>
        <button
          className="btn btn-ghost-success waves-effect waves-light"
          onClick={() => handlePeriodChange(Period.THREE_MONTH)}
          disabled={period === Period.THREE_MONTH}
        >
          {t('ChartsAnalitics.filters.3months')}
        </button>
        <button
          className="btn btn-ghost-success waves-effect waves-light"
          onClick={() => handlePeriodChange(Period.MONTH)}
          disabled={period === Period.MONTH}
        >
          {t('ChartsAnalitics.filters.month')}
        </button>
      </div>
    </div>
  );
};

export default VulsChartTitle;
